import axios from "axios";
import store from "../redux/storeConfig/store";
import { LOGOUT, USER_LOADED } from "../redux/actions/auth/types";
import setAuthToken from "./setAuthToken";
import { REMOVE_DRIVER_DOCUMENT } from "../redux/actions/driver/types";
import { history } from "../history";
const api = axios.create({
  headers: {
    "Content-Type":
      "application/json;application/x-www-form-urlencoded; charset=UTF-8",
  },
});

export const ROOT_URL = "https://api.huluchat.com/";
/**
 intercept any error responses from the api
 and check if the token is no longer valid.
 ie. Token has expired or user is no longer
 authenticated.
 logout the user if the token has expired
**/

api.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      // expired token
      // refreshing token
      //   const prevReq = err.config.url;
      //   const token = localStorage.getItem('token')
      //   const refreshTokenResponse = await api.post(`${ROOT_URL}api/token/refresh/`,{refresh:token})
      //   console.log(refreshTokenResponse)
      //  console.log('prevReq',prevReq)
      // store.dispatch({ type: LOGOUT });
    }
    return res;
  },
  async (err, res) => {
    if (err.response.status === 401) {
      // expired token
      // refreshing token
      //   const prevReq = err.config.url;
      //   const token = localStorage.getItem('token')
      //   const refreshTokenResponse = await api.post(`${ROOT_URL}api/token/refresh/`,{refresh:token})
      //   console.log(refreshTokenResponse)
      //  console.log('prevReq',prevReq)
      // store.dispatch({ type: LOGOUT });
    }

    if (err.response.status === 403) {
      if (!localStorage.getItem("token") || !localStorage.getItem("refresh")) {
        store.dispatch({ type: LOGOUT });
        history.push("/login");
        return;
      }
      const reqUrl = err.config.url;

      if (reqUrl === ROOT_URL + "user/?from=dashboard") {
        const refresh = localStorage.getItem("refresh");
        const refreshTokenResponse = await api.post(
          `${ROOT_URL}api/token/refresh/`,
          { refresh }
        );

        setAuthToken(
          "Bearer " + refreshTokenResponse.data.access,
          refreshTokenResponse.data.refresh
        );
        const retry = await api.get(reqUrl);
        store.dispatch({
          type: USER_LOADED,
          payload: retry.data,
        });
      }
    }
    if (err.response.status === 401) {
            const reqUrl = err.config.url;

      if (reqUrl ===  `${ROOT_URL}api/token/refresh/`) {
        store.dispatch({ type: LOGOUT });
        localStorage.removeItem("token");
        localStorage.removeItem("refresh");
        setAuthToken(null, null);
        history.push("/login");
      }
    }
    return Promise.reject(err);
  }
);

export const uploadDocument = async (
  documentId,
  document,
  percentCompleted,
  dispatch
) => {
  let config = {
    onUploadProgress: function (progressEvent) {
      percentCompleted(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      );
    },
  };

  if (documentId) {
    await api.delete(`${ROOT_URL}dashboard/huluride/documents/${documentId}/`);
    dispatch({ type: REMOVE_DRIVER_DOCUMENT, payload: documentId });
    return api.post(
      `${ROOT_URL}dashboard/huluride/documents/`,
      document,
      config
    );
  }
  return api.post(`${ROOT_URL}dashboard/huluride/documents/`, document, config);
};
export const deleteDocument = async (
  documentId,
  dispatch
) => {

  
    await api.delete(`${ROOT_URL}dashboard/huluride/documents/${documentId}/`);
    dispatch({ type: REMOVE_DRIVER_DOCUMENT, payload: documentId });
   
};
export const uploadPhoto = async (document, percentCompleted) => {
  let config = {
    onUploadProgress: function (progressEvent) {
      percentCompleted(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      );
    },
  };

  return api.post(`${ROOT_URL}photo.upload/`, document, config);
};

export default api;
